export default __webpack_public_path__ + "static/aaa-sm-6dfe3901b5d9fe9f91eb4ebe772f36d3.svg";